import { atom, useRecoilState } from "recoil";

import { Pixels } from "../lib/drawing";

export type Tool = "brush" | "flood" | "line";

const toolState = atom<Tool>({
  key: "toolState",
  default: "brush",
});

const toolShadowState = atom<Pixels>({
  key: "toolShadowState",
  default: {},
});

interface ToolHook {
  tool: Tool;
  setTool: (tool: Tool) => void;
  toolShadow: Pixels;
  setToolShadow: (pixels: Pixels) => void;
}

export function useTool(): ToolHook {
  const [tool, setTool] = useRecoilState(toolState);
  const [toolShadow, setToolShadow] = useRecoilState(toolShadowState);
  return {
    tool,
    setTool,
    toolShadow,
    setToolShadow,
  };
}
